import { Message, SpecialOffer } from '../../../PdpProductProvider/types';
import { getCleanHtml } from '@jbhi-fi/utils/src/getCleanHtml';
import { formatInTimeZone } from 'date-fns-tz';

const CONTENT_REGEX = /&lt;disclaimer&gt;|&lt;cta.*?&gt;|&lt;chat\s*(.*?)?\/?&gt;/;
const LINK_REGEX = /&lt;cta\shref="(.*?)"&gt;(.*?)&lt;\/cta&gt;*/;
const CHAT_REGEX = /&lt;chat\sdepartment="(.*?)"&gt;(.*?)&lt;\/chat&gt;/;
const DISCLAIMER_REGEX = /&lt;disclaimer&gt;(.*?)&lt;\/disclaimer&gt*/;

export const parseSpecialOffer = (message: Message, storeTimeZone?: string): SpecialOffer => {
  const sanitizedContent = getCleanHtml(message.description).replaceAll(/<p><\/p>/g, '');

  const title = message?.heading;
  const content = sanitizedContent
    .split(CONTENT_REGEX)?.[0]
    .replaceAll(/<p>\s*$/g, '')
    .trim();
  const imageUrl = message?.heroBannerImageUrl;

  // Get URL & remove parameters
  const linkResults = sanitizedContent.match(LINK_REGEX);
  const linkUrl = linkResults?.[1].replace(/\?.*$/, '').replace(/#.*$/, '') ?? undefined;
  const linkContent = linkResults?.[2] ?? undefined;

  const matchedChat = sanitizedContent.match(CHAT_REGEX);
  const chat = matchedChat
    ? {
        label: matchedChat[2] !== '' ? matchedChat[2] : 'Chat with us',
        department: matchedChat[1] ?? undefined,
      }
    : undefined;

  // Get disclaimer & convert unicode to html tags
  const disclaimerResult = sanitizedContent.match(DISCLAIMER_REGEX)?.[1] ?? undefined;
  const disclaimer = disclaimerResult?.replaceAll('&lt;', '<').replaceAll('&gt;', '>');

  const formattedDate = message.finish
    ? formatInTimeZone(new Date(message.finish), storeTimeZone ?? 'Australia/Melbourne', 'd MMM yyyy')
    : undefined;

  return {
    title,
    content,
    imageUrl,
    disclaimer,
    chat,
    links: linkUrl ? [{ label: linkContent, url: linkUrl }] : undefined,
    endDate: formattedDate,
  };
};
